export const GEOCODER = {
  app_id: 'o9tLFPqdtRQi8LWjKFSI',
  app_code: 'NuBX-RjelCL0sIuvzOTn6Q',
};

export const PDE = {
  app_id: 'o9tLFPqdtRQi8LWjKFSI',
  app_code: 'NuBX-RjelCL0sIuvzOTn6Q',
};
